import React from "react";
import Grid from "@material-ui/core/Grid";
import { ListItem, Typography } from "@material-ui/core";
import PanToolIcon from "@material-ui/icons/PanTool";
import List from "@material-ui/core/List";
import { Alert } from "@material-ui/lab";
import { useGameContextContext } from "../../../state/game-context/context";
import commonStyles from "../../common/styles/Common.styles";

const MissingGameDataContainer = () => {
	const commonClasses = commonStyles();

	const { state } = useGameContextContext();
	const missingGameData = state.missingGameData();

	return (
		<Grid
			container
			align="center"
			spacing={4}
			alignItems="center"
			className={commonClasses.container}
		>
			<Grid item md={12}>
				<PanToolIcon className={commonClasses.contentCenteredIcon} />
				<Typography variant="h3">Missing game data</Typography>
				<Typography variant="body1">
					To begin the game, please complete the following setup items
				</Typography>
				<List>
					{missingGameData.map((d) => (
						<ListItem key={d.message}>
							<Alert severity="info" style={{ width: "100%" }}>
								{d.message}
							</Alert>
						</ListItem>
					))}
				</List>
			</Grid>
		</Grid>
	);
};

export default MissingGameDataContainer;
